export class CopilotTaskChecklistSuggestionsRequestDTO {
  name: string;

  description: string;

  steps: string[];

  constructor() {
    this.name = '';
    this.description = '';
    this.steps = [];
  }
}

export class CopilotTaskChecklistSuggestionsDTO {
  steps?: string[];

  message?: string;
}
